const deDE = {
    crossmintPayButtonService: {
        CONNECTING: "Verbindung wird hergestellt...",
        BUY: "Mit Crossmint kaufen",
        BUY_WITH_ETH: "Mit ETH kaufen",
        BUY_WITH_SOL: "Mit SOL kaufen",
        BUY_WITH_CREDIT_CARD: "Mit Kreditkarte kaufen",
    },
};
export default deDE;
